// extracted by mini-css-extract-plugin
export default {"table":"table_table__eO6i0","cellWrapper":"table_cellWrapper__TF2kW","image":"table_image__vL7sT","productStatus":"table_productStatus__AeqG3"};